// extracted by mini-css-extract-plugin
module.exports = {"Community":"Community_Community__PgOUv","backgroundImage":"Community_backgroundImage__Byosg","cta":"Community_cta__4a0_6","socials":"Community_socials__SgqqY"};